const radius = 4;

export default () => ({
    '& .ql-editor': {
        minHeight: '20rem',
    },
    '& .ql-toolbar': {
        borderTopLeftRadius: `${radius}px`,
        borderTopRightRadius: `${radius}px`,
    },
    '& .ql-container': {
        borderBottomLeftRadius: `${radius}px`,
        borderBottomRightRadius: `${radius}px`,
    },
});
